export default class Pagination {
  /** @type {NodeListOf<HTMLElement>} */
  items;

  /** @type {number} */
  itemsPerPage;

  /** @type {number} */
  minPagesForDots;

  /** @type {undefined|string} */
  arrowPrev = undefined;
  /** @type {undefined|string} */
  arrowNext = undefined;
  /** @type {HTMLElement} */
  faqElement;

  constructor(
    faqElement,
    items,
    itemsPerPage = 10,
    minPagesForDots = 5,
    arrowPrev = undefined,
    arrowNext = undefined,
    faqCategory = document.querySelector(
      ".filter-tabs__item.filter-tabs__item--active"
    ).dataset.faqCategory
  ) {
    this.items = items;
    this.itemsPerPage = itemsPerPage;
    this.minPagesForDots = minPagesForDots;
    this.offset = 0;
    this.page = 0;
    this.faqCategory = faqCategory;

    this.faqElement = faqElement;

    this.build(faqElement, faqCategory);

    this.arrowPrev = arrowPrev;
    this.arrowNext = arrowNext;

    const pagination = this.faqElement.querySelector(
      ".faq__pagination .pagination"
    );
    if (pagination) {
      this.arrows();
    }
  }

  /** @returns {this} */
  arrows() {
    if (this.arrowNext) {
      this.faqElement.querySelector(this.arrowNext).onclick = (e) => {
        e.preventDefault();

        const activeNode = this.faqElement.querySelector(
          ".pagination__item--active"
        );
        activeNode.nextElementSibling
          ?.querySelector("a")
          .dispatchEvent(
            new Event("click", { cancelable: false, bubbles: true })
          );
      };
    }
    if (this.arrowPrev) {
      this.faqElement.querySelector(this.arrowPrev).onclick = (e) => {
        e.preventDefault();

        const activeNode = this.faqElement.querySelector(
          ".pagination__item--active"
        );
        activeNode.previousElementSibling
          ?.querySelector("a")
          .dispatchEvent(
            new Event("click", { cancelable: false, bubbles: true })
          );
      };
    }

    return this;
  }

  build(faqCategory = undefined, searchTerm = undefined) {
    const node = this.faqElement.querySelector(".faq__pagination .pagination");
    if (node) node.parentNode.removeChild(node);

    let baseHTML = `
      <div class="pagination">
        <div class="pagination__arrow pagination__arrow--prev" style="visibility: hidden;">
          <a class="pagination__action">
            <img class="pagination__icon pagination__icon--gray" src="/fileadmin/arrows/chevron-right-gray.svg" alt="Weiter" />
            <img class="pagination__icon pagination__icon--yellow" src="/fileadmin/arrows/chevron-right-yellow.svg" alt="Weiter" />
          </a>
        </div>

        <div class="pagination__pages">`;

    const filteredItems = [...this.items].filter(function (item, index) {
      if (faqCategory === undefined && searchTerm === undefined) {
        return true;
      } else if (searchTerm) {
        return item.textContent
          .toLowerCase()
          .includes(searchTerm.toLowerCase());
      }

      return parseInt(item.dataset.faqCategory) === parseInt(faqCategory);
    });

    const totalPages = Math.ceil(filteredItems.length / this.itemsPerPage);

    const showDots = totalPages > this.minPagesForDots;
    const leftOvers = [];

    if (totalPages) {
      for (let i = 0; i !== totalPages; i++) {
        if (i >= this.minPagesForDots) {
          leftOvers.push(i);
          continue;
        }

        baseHTML += `
            <div class="pagination__item${
              i === 0 ? " pagination__item--active" : ""
            }">
              <a class="pagination__action">${i + 1}</a>
            </div>
          `;
      }
    }

    const pagination = this.faqElement.querySelector(".faq__pagination");

    if (pagination) {
      if (filteredItems.length <= this.itemsPerPage) {
        pagination.setAttribute("hidden", "hidden");
      } else {
        pagination.removeAttribute("hidden", "hidden");
      }

      if (showDots) {
        if (totalPages > 5) {
        }
        baseHTML += leftOvers
          .map(
            (i) => `
          <div class="pagination__item" hidden>
            <a class="pagination__action">${i + 1}</a>
          </div>`
          )
          .join("");
      }

      baseHTML += `
          </div>

          <div class="pagination__arrow pagination__arrow--next">
            <a class="pagination__action">
              <img class="pagination__icon pagination__icon--gray" src="/fileadmin/arrows/chevron-right-gray.svg" alt="Zurück" />
              <img class="pagination__icon pagination__icon--yellow" src="/fileadmin/arrows/chevron-right-yellow.svg" alt="Zurück" />
            </a>
          </div>
        `;

      this.faqElement
        .querySelector(".faq__pagination")
        .insertAdjacentHTML("beforeend", baseHTML);

      setTimeout(() => this.arrows(), 1);

      return baseHTML;
    }
  }

  paginate(directionOrPage, faqCategory = undefined, searchTerm = undefined) {
    if (directionOrPage === "+" || directionOrPage === "-") {
      if (directionOrPage === "+") this.page++;
      else this.page--;
    } else {
      this.page = directionOrPage;
    }

    this.offset = (this.page - 1) * this.itemsPerPage;
    const start = this.offset;
    const end = start + this.itemsPerPage;

    const filteredItems = [...this.items].filter(function (item, index) {
      if (faqCategory === undefined && searchTerm === undefined) {
        return true;
      } else if (searchTerm) {
        const lowerItemText = item.textContent.toLowerCase();
        const lowerSearchText = searchTerm.toString().toLowerCase();

        return lowerItemText.includes(lowerSearchText);
      }

      return parseInt(item.dataset.faqCategory) === parseInt(faqCategory);
    });

    const pagination = this.faqElement.querySelector(".faq__pagination");

    if (pagination) {
      if (filteredItems.length <= this.itemsPerPage) {
        pagination.setAttribute("hidden", "hidden");
      } else {
        pagination.removeAttribute("hidden", "hidden");
      }
    }

    const slicedItems = filteredItems.slice(start, end);
    const itemsNotInSlice = filteredItems.filter(
      (item, index) => index < start || index >= end
    );

    return {
      itemsToShow: slicedItems,
      itemsToHide: itemsNotInSlice,
    };
  }
}
